import utilits from '@/assets/utilits/request.js'
export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },

  actions: {
    getallbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getallbilling', obj, callback)
    },
    getuserbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/getuserbilling', obj, callback)
    },
    geto3desc ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/geto3desc', obj, callback)
    },
    setbillinguser ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/setbillinguser', obj, callback)
    },
    addbudgetinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/addbudgetinfo', obj, callback)
    },
    updatebudgetinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/updatebudgetinfo', obj, callback)
    },
    delbudgetinfo ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/delbudgetinfo', obj, callback)
    },
    getbudgetbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/getbudgetbilling', obj, callback)
    },
    getbillingrules ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/getbillingrules', obj, callback)
    },
    updatebillingrules ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/updatebillingrules', obj, callback)
    },
    getownerbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.get, '/cmpapi/getownerbilling', obj, callback)
    },
    exportbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/exportbilling', obj, callback)
    },
    downloadfile ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/downloadfile', obj, callback, true)
    },
    checkfile ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/checkfile', obj, callback)
    },
    // 重新计算账单
    remathbilling ({ context, state }, obj, callback) {
      return utilits.httpRequest(utilits.post, '/cmpapi/remathbilling', obj, callback)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bill.js